export type UpdatePartnerRequest = {
  ptnrId: string;
  ptnrCd: string;
  ptnrName: string;
  ptnrNameWtngChng: string;
  ptnrTypeCd: string;
  buCnTypeCd: string;
  buCd: string;
  cnCd: string;
  dipByRgn: string;
  cpntId: string;
  delFlg: string;
  updtDtimePtnr: string;
  chnTypeList: {
    index: number;
    chnTypeDelFlg: string;
    inOutTypeCd: string;
    chnTypeCd: string;
    fileTypeCd: string;
    updtDtimePtnrChnType: string;
  }[];
};
